import { track } from './analytics';

/**
 * Send the CURRENT tab to our branded /checkout page (pages/Checkout.js).
 * The card form is embedded there (Stripe Elements + Checkout Sessions API);
 * when the embedded form isn't available the page falls back to Stripe's
 * hosted checkout with the chosen coupon pre-applied.
 *
 * `code` (optional) is a promotion code to auto-apply — used when the user
 * arrives from the exit-intent / "Maybe later" discount popups.
 *
 * Sets a `pro_checkout_pending` flag so that if the user drops off mid
 * checkout (back button, card declined, closed tab), the onboarding flow can
 * resume the checkout instead of silently downgrading them to a free account.
 */
export async function startProCheckout(value, code) {
  track('begin_checkout', { plan_id: 'pro', value: Number(value) || 0, code: code || '' });
  localStorage.setItem('pro_checkout_pending', '1');
  const url = code ? `/checkout?code=${encodeURIComponent(String(code).toUpperCase())}` : '/checkout';
  window.location.assign(url);
  return url;
}

/**
 * Open the global Pro upgrade window (see components/UpgradeModal.js).
 * Free users who click Pro content get the pitch + "Maybe later" discount
 * offer instead of being thrown straight into checkout.
 */
export function goPro() {
  window.dispatchEvent(new CustomEvent('cmx:open-upgrade'));
  return true;
}
